<template>
  <div class="mb-3" :class="FormDataType.FieldSize">
    <b-form-group :class="title_position" id="example text" :label-cols-lg="labels_lg" :label="FormDataType.FieldTitle"
      label-for="text">
      <textarea :rows="rows" :class="{ 'is-invalid': v.$error }" v-model="InputName" @input="$emit('input', InputName)"
        class="form-control" :disabled="FormDataType.Disabled"></textarea>

      <template v-if="v.$error">
        <div v-for="(error, index) of v.$silentErrors" :key="index">
          <div>
            <span v-if="error.$validator == 'required'">{{ $t("ValidationMessage.required") }}</span>
            <span v-else>{{ error.$message }}</span>
          </div>
        </div>
      </template>
    </b-form-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      InputName: "",
    };
  },
  props: {
    v: {
      type: Object,
    },
    FormDataType: {},
    FormPost: String,
    Value: String,
    title_position: String,
    labels_lg: Number,
    rows: Number,
  },
  watch: {
    FormPost() {
      this.$v.$touch();
    },
    Value() {
      this.InputName = this.Value;
    },
  },
  created: function () {
    this.InputName = this.Value;
  },
};
</script>
